package nl.appstuff.padelchecker.site.components.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import nl.appstuff.padelchecker.site.SiteColors
import nl.appstuff.padelchecker.site.localization.LocalSiteStrings
import nl.appstuff.padelchecker.site.localization.SiteStrings
import org.jetbrains.compose.web.css.*

private data class FaqItem(val title: String, val content: String)

private fun SiteStrings.faqItems(): List<FaqItem> = listOf(
    FaqItem(faqItem1Question, faqItem1Answer),
    FaqItem(faqItem2Question, faqItem2Answer),
    FaqItem(faqItem3Question, faqItem3Answer),
    FaqItem(faqItem4Question, faqItem4Answer),
    FaqItem(faqItem5Question, faqItem5Answer),
    FaqItem(faqItem6Question, faqItem6Answer),
)

@Composable
fun FaqSection() {
    val strings = LocalSiteStrings.current
    val faqItems = strings.faqItems()
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = 80.px, leftRight = 24.px)
            .id("faq"),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(760.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(48.px),
        ) {
            SpanText(
                strings.faqTitle,
                modifier = Modifier
                    .fontSize(38.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(SiteColors.textLight)
                    .textAlign(TextAlign.Center),
            )

            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(0.px),
            ) {
                faqItems.forEach { item ->
                    FaqAccordionItem(item = item)
                }
            }
        }
    }
}

@Composable
private fun FaqAccordionItem(
    item: FaqItem,
) {
    var expanded by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.fillMaxWidth(),
    ) {
        // Header row — tap/click to toggle
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = 24.px, topBottom = 20.px)
                .cursor(Cursor.Pointer)
                .onClick { expanded = !expanded },
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            SpanText(
                item.title,
                modifier = Modifier
                    .fontSize(16.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(SiteColors.textLight)
                    .flex(1),
            )
            SpanText(
                if (expanded) "−" else "+",
                modifier = Modifier
                    .fontSize(22.px)
                    .fontWeight(FontWeight.Bold)
                    .color(SiteColors.textLight),
            )
        }

        // Content (shown when expanded)
        if (expanded) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(left = 24.px, right = 24.px, bottom = 20.px),
            ) {
                SpanText(
                    item.content,
                    modifier = Modifier
                        .fontSize(15.px)
                        .lineHeight(1.7)
                        .color(SiteColors.textMutedLight)
                        .styleModifier { property("white-space", "pre-line") },
                )
            }
        }
    }
}
